module.exports = __webpack_public_path__ + "img/request-collection.9f2744d6.svg";